export class FileStringReader {

  public static read(file: File): Promise<string> {

    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event: any) => {
        const data = event.target.result;

        try {
          resolve(data);
        } catch (error) {
          reject('Could not read file: ' + error);
        }
      };

      reader.onerror = (event: any) => {
        reject('Could not read file: ' + event);
      };

      reader.readAsText(file);
    });
  }
}
